/**
 * This class is used to define firebase configuration data
*/
const firebaseConfig = {
  apiKey: "AIzaSyCkecupk_YpgTpBE2nmhmHWUAALZJj1oJ0",
  authDomain: "justiexpress-d82e3.firebaseapp.com",
  projectId: "justiexpress-d82e3",
  storageBucket: "justiexpress-d82e3.appspot.com",
  messagingSenderId: "303687685396",
  appId: "1:303687685396:web:700529db1e13d09fa25e01",
  measurementId: "G-4400RSJXX3"
};

export default firebaseConfig;
